<template>
<div>
    <vue-recaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" @verify = "validate" />
</div>
</template>
<script>
import {VueRecaptcha} from "vue-recaptcha"
export default {
    components: { VueRecaptcha },
    data() {
        return {
            sitekey: process.env.VUE_APP_RECAPTCHA_KEY
        }
    },
    methods: {
        validate(response) {
           // console.log(response)
           this.$emit('validate', response)
        }
    }
}
</script>